import { Controller } from "@hotwired/stimulus"

// Меню сайта на узком экране. Пункты те же, что на десктопе — одна разметка,
// которую CSS превращает в выпадающую панель; отдельного мобильного меню нет,
// иначе ссылки пришлось бы держать в двух местах и они бы разъезжались.
//
// Админский sidebar_controller не переиспользуем: он дёргает Tailwind-класс
// -translate-x-full, а сайт живёт на своём слое .pc-*.
export default class extends Controller {
  static targets = ["panel", "button"]

  // Turbo сохраняет DOM между переходами: панель, открытая перед кликом по
  // ссылке, осталась бы открытой на новой странице.
  connect() {
    this.close()
  }

  toggle() {
    this.panelTarget.classList.contains("is-open") ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.add("is-open")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.classList.remove("is-open")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  // Клик мимо шапки и Escape закрывают панель: открытая, она накрывает начало
  // страницы, и без этого закрыть её можно только повторным попаданием в иконку.
  closeOnOutside(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
